import React from 'react';
import Menu from '../../containers/MenuContainer';
import './styles.css';
export default ({children, history})=>

	<main>
		<header className="header"></header>
		<Menu/>
	 	<section className="page">
      	 	{children}
	 	</section>
	</main>


// WEBPACK FOOTER //
// ./src/components/Wrapper/index.js